import { render, staticRenderFns } from "./FirstBlock.vue?vue&type=template&id=be11321e&scoped=true"
import script from "./FirstBlock.vue?vue&type=script&lang=js"
export * from "./FirstBlock.vue?vue&type=script&lang=js"
import style0 from "./FirstBlock.vue?vue&type=style&index=0&id=be11321e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be11321e",
  null
  
)

export default component.exports